<nav class="sidebar">
  <div class="sidebar-header">

    <!--- Logo -->

    <a routerLink="/" class="sidebar-brand xfeet-logo">
      <img src="assets/images/XFeet_Logo_app-60px.png" alt="logo">
    </a>

    <!--- Toggler -->
    <div class="sidebar-toggler not-active" #sidebarToggler (click)="toggleSidebar($event)">
      <span></span>
      <span></span>
      <span></span>
    </div>

  </div>
  <div class="sidebar-body" (mouseenter)="operSidebarFolded()" (mouseleave)="closeSidebarFolded()">

    <!--- Sidemenu start -->

    <ul class="sidebar-nav metismenu" id="sidebar-menu" #sidebarMenu>
      @for (item of menuItems; track item) {
        @if (item.isTitle && ((item?.roles || []) | currentUserInRole)) {
          <li class="nav-item nav-category">{{ item.label | translate }}</li>
        }
        @if (!item.isTitle && ((item?.roles || []) | currentUserInRole)) {
          <li class="nav-item">
            @if (hasItems(item)) {
              <a class="nav-link" href="javascript:void(0);">
                @if (item.icon) {
                  <i class="link-icon" [ngClass]="item.icon"></i>
                }
                <span class="link-title"> {{ item.label | translate }}</span>
                <span class="link-arrow" data-feather="chevron-down" appFeatherIcon></span>
              </a>
            }
            @if (!hasItems(item) && ((item?.roles || []) | currentUserInRole)) {
              <a class="nav-link nav-link-ref" [routerLink]="item.link"
                [attr.data-parent]="item.parentId">
                @if (item.icon) {
                  <i class="link-icon" [ngClass]="item.icon"></i>
                }
                <span class="link-title"> {{ item.label | translate }}</span>
                @if (item.badge) {
                  <span class="badge bg-{{item.badge.variant}}">{{item.badge.text}}</span>
                }
              </a>
            }
            @if (hasItems(item)) {
              <ul class="sidebar-nav sub-menu nav-second-level" aria-expanded="false">
                @for (subitem of item.subItems; track subitem) {
                  @if ((subitem?.roles || []) | currentUserInRole) {
                    <li class="nav-item" [ngClass]="{'side-nav-item': hasItems(subitem)}">
                      @if (hasItems(subitem)) {
                        <a class="nav-link side-nav-link-a-ref" href="javascript:void(0);">
                          @if (subitem.icon) {
                            <i class="link-icon" [ngClass]="subitem.icon"></i>
                          }
                          <span class="link-title"> {{ subitem.label | translate }}</span>
                          <span class="link-arrow" data-feather="chevron-down" appFeatherIcon></span>
                        </a>
                      }
                      @if (!hasItems(subitem) && ((subitem?.roles || []) | currentUserInRole)) {
                        <a class="nav-link nav-link-ref" [routerLink]="subitem.link"
                          [attr.data-parent]="subitem.parentId">
                          @if (subitem.icon) {
                            <i class="link-icon" [ngClass]="subitem.icon"></i>
                          }
                          {{ subitem.label | translate }}
                        </a>
                      }
                      @if (hasItems(subitem)) {
                        <ul class="sidebar-nav sub-menu nav-third-level" aria-expanded="false">
                          @for (subSubitem of subitem.subItems; track subSubitem) {
                            @if ((subSubitem?.roles || []) | currentUserInRole) {
                              <li class="nav-item">
                                <a class="nav-link nav-link-ref" [routerLink]="subSubitem.link" [routerLinkActive]="['active']"
                                  [attr.data-parent]="subSubitem.parentId">
                                  @if (subitem.icon) {
                                    <i class="link-icon"[ngClass]="subitem.icon"></i>
                                  }
                                  {{ subSubitem.label | translate }}
                                </a>
                              </li>
                            }
                          }
                        </ul>
                      }
                    </li>
                  }
                }
              </ul>
            }
          </li>
        }
      }
    <!--li class="nav-item nav-category">Docs</li>
    <li class="nav-item">
      <a href="https://www.xfeet-orthotics.com/documentation/docs.html" target="_blank" class="nav-link">
        <i class="link-icon" data-feather="hash" appFeatherIcon></i>
        <span class="link-title">Documentation</span>
      </a>
    </li-->
  </ul>

  <!--- Sidemenu end -->

</div>
</nav>
<!--nav class="settings-sidebar">
<div class="sidebar-body">
  <a href="" class="settings-sidebar-toggler" (click)="toggleSettingsSidebar($event)">
    <i class="icon feather icon-settings"></i>
  </a>
  <h6 class="text-muted mb-2">Sidebar:</h6>
  <div class="mb-3 pb-3 border-bottom">
    <div class="form-check form-check-inline">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="sidebarThemeSettings" (change)="onSidebarThemeChange($event)" id="sidebarLight" value="sidebar-light" checked>
        <i class="input-frame"></i>
        Light
      </label>
    </div>
    <div class="form-check form-check-inline">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="sidebarThemeSettings" (change)="onSidebarThemeChange($event)" id="sidebarDark" value="sidebar-dark">
        <i class="input-frame"></i>
        Dark
      </label>
    </div>
  </div>
</div>
</nav-->
